<template>
  <div class="w-full">
    <h6 class="dashboard__green">Personas más Invitadas</h6>
    <div class="dashboard__card_container w-full">
      <v-data-table class="dashboard__table w-full dashboard__normal_table" :headers="headers"
        :pagination.sync="pagination" :loading="isLoadingTopInvitations" :items="topInvitations?.data || []"
        :rows-per-page-items="[6]" :total-items="topInvitations?.total_count || 0">

        <template v-slot:progress>
          <v-progress-linear color="blue" indeterminate height="3"></v-progress-linear>
        </template>

        <template v-slot:no-data>
          <v-alert class="empty-alert" type="info" :value="true">
            {{ emptyStateMessage }}
          </v-alert>
        </template>
        <template v-slot:items="props">
          <tr>
            <td><span class="dashboard__profile_image"
                :style="{ 'background-image': `url(${props.item.data_inviter?.picture || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'})` }"></span>
            </td>
            <td class="text-xs-left">{{ props.item.data_inviter?.name }}</td>
            <td><span class="dashboard__profile_image"
                :style="{ 'background-image': `url(${props.item.data_invitation?.photo || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'})` }"></span>
            </td>
            <td class="text-xs-left">{{ props.item.data_invitation?.name }}</td>
            <td class="text-xs-left" @click="openInvitationDetail({
              inviter: {
                id: props.item.data_inviter.id,
                name: props.item.data_inviter.name
              },
              invited: {
                name: props.item.data_invitation.name
              },
              mobile: props.item.mobile,
              month: ''
            })">{{ props.item.total_count }}</td>
            <td v-for="(header, index) in headers.slice(5)" :key="index" @click="openInvitationDetail({
              inviter: {
                id: props.item.data_inviter.id,
                name: props.item.data_inviter.name
              },
              invited: {
                name: props.item.data_invitation.name
              },
              mobile: props.item.mobile,
              month: `2025-${getMonthNumber(header.value)}`
            })"
              :class="isHighestMonth(props.item.count_per_month, header.value) ? 'dashboard__table_accent_cell' : ''">
              {{props.item.count_per_month?.find(data => data.month === header.value)?.count || 0}}
            </td>
          </tr>

        </template>

      </v-data-table>
      <InvitationDetailModal v-model="dialog" :selectedInvitation="selectedItem" @input="handleClose" />
    </div>
  </div>
</template>
<script>
import DashboardService from '../../../services/DashboardService';
import InvitationDetailModal from '../../dashboard/InvitationDetailModal.vue';

const MONTHS_MAP = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12",
};

export default {
  components: { InvitationDetailModal },
  data() {
    return {
      topInvitations: [],
      dialog: false,
      selectedItem: {},
      isLoadingTopInvitations: false,
      pagination: {
        page: 1,
        rowsPerPage: 6,
        descending: false
      },
    }
  },

  mounted() {
    this.isLoadingTopInvitations = true
    this.getTopInvitations().finally(() => {
      this.isLoadingTopInvitations = false;
    })

  },
  computed: {
    headers() {
      const headers = [
        {
          text: "",
          value: "inviter_photo",
          sortable: false

        },
        {
          text: "Invitador",
          value: "inviter_data",
          sortable: false
        },
        {
          text: "",
          value: "invitation_photo",
          sortable: false

        },
        {
          text: "Invitado",
          value: "data_invitation",
          sortable: false
        },
        {
          text: "Invitaciones",
          value: "total_count",
          sortable: false
        },
      ]

      const monthsEs = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ];

      const monthsEn = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      monthsEs.forEach((monthEs, index) => {
        headers.push({
          text: monthEs.substring(0, 3),
          value: monthsEn[index],
          sortable: false
        });
      });

      return headers
    },
    emptyStateMessage() {

      if (this.isLoadingTopInvitations) {
        return "Cargando datos...";
      }

      return "No hay invitaciones"


    }
  },
  methods: {
    async getTopInvitations() {
      try {
        const params = {
          location_id: this.getLocation || null,
          page: this.pagination.page,
          per_page: this.pagination.rowsPerPage
        };
        this.topInvitations = await DashboardService.getTopInvitations(params);
      } catch (err) {
        this.topInvitations = [];
      }
    },
    async handlePagination() {
      this.isLoadingTopInvitations = true;
      await this.getTopInvitations();
      this.isLoadingTopInvitations = false;
    },
    isHighestMonth(countPerMonth, monthName) {

      if (!countPerMonth || countPerMonth.length === 0) return false;

      const maxCount = Math.max(...countPerMonth.map(item => item.count));

      const currentMonth = countPerMonth.find(data => data.month === monthName);

      return currentMonth && currentMonth.count === maxCount;
    },
    openInvitationDetail(item) {
      this.selectedItem = item
      this.dialog = true
    },
    handleClose() {
      this.selectedItem = {}
      this.dialog = false
    },
    getMonthNumber(monthName) {
      return MONTHS_MAP[monthName]
    }
  },
  watch: {
    'getLocation': {
      deep: true,
      handler() {
        this.isLoadingTopInvitations = true
        this.getTopInvitations().finally(() => {
          this.isLoadingTopInvitations = false

        })
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (oldVal && (newVal.page !== oldVal.page || newVal.rowsPerPage !== oldVal.rowsPerPage)) {
          this.handlePagination()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/stylesheets/utilities/_mixins.scss";

.empty-alert {
  @include empty-alert();
}
</style>